<div class="actions">
  <capra-icon
    capraTooltip
    data-test="copy-secret-cta"
    tooltipContent="Copy secret to clipboard (Display name)"
    tooltipPlacement="left"
    tooltipSize="mini"
    icon="icon-copy-chart"
    modeClipboard
    successToastMessage="Display name copied to clipboard"
    [clipboardText]="secret.key"
  >
  </capra-icon>
  <capra-icon
    type="button"
    cdkOverlayOrigin
    data-test="actions-secret-cta"
    #newCellTrigger="cdkOverlayOrigin"
    icon="icon-caret-down"
    (click)="handleDialog()"
  >
  </capra-icon>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="newCellTrigger"
  [cdkConnectedOverlayOpen]="isDialogOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="handleDialog()"
>
  <ul class="overlay">
    <li role="button" (click)="edit($event)">Update secret</li>
    <li role="button" (click)="delete($event)">Delete secret</li>
  </ul>
</ng-template>
